<template>
  <div style="display: flex;flex-direction: row;margin-top: 30px;min-height: 621.5px">
    <div v-if="questionInfo.subjectInfo && questionInfo.subjectInfo.selections" style="margin-right: 30px">
      <div
        style="display: flex;flex-direction: row;margin-bottom: 5px;margin-left: 5px;padding-right: 5px;color: #c0c0c0;font-size: 14px">
        题目详情
      </div>
      <el-card style="border-radius: 8px;min-width: 500px;width:500px;max-width: 500px"
               :body-style="{padding:'0px'}">
        <div style="padding: 15px">
          <div style="display: flex;flex-direction: column">
            <a class="material" v-html="questionInfo.subjectInfo.subjectDes"></a>
            <a class="material" style="font-size: 13px;margin-top: 10px"
               v-html="questionInfo.subjectInfo.materialDecript"></a>
          </div>
          <div style="background-color: #f9f9f9;border-radius: 8px;margin-top: 15px">
            <div style="display: flex;flex-direction: row;">
              <a class="subjectSelectionTop">{{ questionInfo.subjectInfo.selections[0].itemIndex }}</a>
              <a class="subjectSelectionDes" v-html="questionInfo.subjectInfo.selections[0].itemDecript"></a>
            </div>
            <div style="height: 1px;width: 100%;background-color: #f2f2f2"/>
            <div style="display: flex;flex-direction: row;">
              <a class="subjectSelection">{{ questionInfo.subjectInfo.selections[1].itemIndex }}</a>
              <a class="subjectSelectionDes" v-html="questionInfo.subjectInfo.selections[1].itemDecript"></a>
            </div>
            <div style="height: 1px;width: 100%;background-color: #f2f2f2"/>
            <div style="display: flex;flex-direction: row;">
              <a class="subjectSelection">{{ questionInfo.subjectInfo.selections[2].itemIndex }}</a>
              <a class="subjectSelectionDes" v-html="questionInfo.subjectInfo.selections[2].itemDecript"></a>
            </div>
            <div style="height: 1px;width: 100%;background-color: #f2f2f2"/>
            <div style="display: flex;flex-direction: row;">
              <a class="subjectSelectionBottom">{{ questionInfo.subjectInfo.selections[3].itemIndex }}</a>
              <a class="subjectSelectionDes" v-html="questionInfo.subjectInfo.selections[3].itemDecript"></a>
            </div>
          </div>
          <div style="margin-top: 15px">
            <p>解析</p>
            <a class="subjectSelectionDes" v-html="questionInfo.subjectInfo.analysis"></a>
          </div>
        </div>
      </el-card>
    </div>
    <div style="width: 100%;">
      <div style="color: #c0c0c0;font-size: 14px;margin-bottom: 5px;margin-left: 5px;display: flex;flex-direction: row">
        问题详情
        <a
          style="color: #ffbc42;margin-left: 5px">{{
            questionInfo.question_page_title
          }}</a>
        <router-link style="color:#ffbc42;font-size: 14px;margin-left: auto;margin-right: 5px;font-weight: bold"
                     :to="{name: 'download'}">
          我也有疑问
        </router-link>
      </div>
      <div>
        <el-card style="border-radius: 8px" :body-style="{padding:'0px'}">
          <div style="display: flex;flex-direction: row;align-items: center;padding: 15px;font-size: 14px">
            <img style="width: 30px;height: 30px;border-radius: 50%" :src="questionInfo.userInfo.imageUrl"
                 :onerror="defaultImg">
            <a style="color: #666666;margin-left: 10px">{{ userCheck(questionInfo.userInfo.nickname) }}</a>
            <div style="color: #666666;margin-left: auto">{{ delTimeTag(questionInfo.commentTime) }}</div>
          </div>
          <div style="display: flex;flex-direction: row;padding-left: 15px;padding-bottom: 15px;padding-right: 15px">
            <a style="color: #333333;margin-left: 5px; font-size: 15px">{{
                questionInfo.reviewContent
              }}</a>
          </div>
        </el-card>
        <div style="color: #c0c0c0;font-size: 14px;margin-bottom: 5px;margin-left: 5px;margin-top: 30px">
          回答列表
        </div>
        <el-card style="margin-top: 5px;border-radius: 8px" :body-style="{padding:'0px'}">
          <div v-for="(item, index) in questionReviewList">
            <div :class="index % 2 === 0 ? 'info_title_new' : 'info_title_new2'">
              <div
                style="display: flex;flex-direction: row;width: 100%;align-items: center;margin-bottom: 15px;padding-top: 15px">
                <img style="width: 30px;height: 30px;border-radius: 50%;margin-left: 15px;"
                     :src="item.userInfo.imageUrl" :onerror="defaultImg">
                <a style="color: #666666;margin-left: 10px">{{ userCheck(item.userInfo.nickname) }}</a>
                <div style="color: #666666;margin-left: auto;margin-right: 15px">{{
                    delTimeTag(item.commentTime)
                  }}
                </div>
              </div>
              <div style="color: #333333;margin-left: 15px;font-size: 15px;padding-bottom: 15px">
                {{ item.reviewContent }}
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import {getQuizDetail, getQuizCommentList} from "../../networks/QuizRequestHandler"
import userPhoto from '../../common/imgs/default_icon.png'

export default {
  data() {
    return {
      questionInfo: {},
      questionReviewList: [],
    }
  },
  mounted: function () {
    this.getData()
  },
  beforeRouteEnter(to, from, next) {
    if (from.name === 'download') { //判断是从哪个路由过来的，若是detail页面不需要刷新获取新数据，直接用之前缓存的数据即可
      to.meta.isBack = true;
    }
    next();
  },
  activated() {
    if (!this.$route.meta.isBack) {
      this.data = ''
      this.getData();
    }
    this.$route.meta.isBack = false
  },
  computed: {
    defaultImg() {
      return 'this.src="' + userPhoto + '"';
    }
  },
  methods: {
    getData: function () {
      var context = this;
      var promise = getQuizDetail(this.$route.params.quiz_id);
      promise.then(function (r) {
        context.questionInfo = r.questionInfo;
        console.log(r)
        context.getCommentList();
      }).catch(function (error) {
      });
    },
    getCommentList: function () {
      var context = this;
      var promise = getQuizCommentList(this.$route.params.quiz_id);
      promise.then(function (r) {
        context.questionReviewList = r.questionReviewList;
      }).catch(function (error) {
      });
    },
    delTimeTag: function (str) {
      if (!$.isEmptyObject(str)) {
        str = str.replace('T', " ");
      }
      return str
    },
    userCheck: function (str) {
      if ($.isEmptyObject(str)) {
        str = '必胜用户'
      }
      return str
    },
  }
};
</script>

<style>
.info_title_new {
  background-color: #ffffff;
  color: #555555;
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.info_title_new2 {
  background-color: #f8f8f8;
  color: #555555;
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.subjectSelectionDes {
  padding: 10px;
  font-size: 13px;
  color: #666666;
}

.subjectSelection {
  min-width: 30px;
  background-color: #f2f2f2;
  display: flex;
  font-weight: bold;
  align-items: center;
  justify-content: center
}

.subjectSelectionTop {
  min-width: 30px;
  background-color: #f2f2f2;
  border-top-left-radius: 8px;
  display: flex;
  font-weight: bold;
  align-items: center;
  justify-content: center
}

.subjectSelectionBottom {
  min-width: 30px;
  background-color: #f2f2f2;
  border-bottom-left-radius: 8px;
  display: flex;
  font-weight: bold;
  align-items: center;
  justify-content: center
}

.material img {
  max-width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Quiz/QuizDetail.vue